import i18n from 'i18n';

// Translates a single room name if it follows the pattern "Room X"
export const translateBreakoutDefaultRoomName = (name: string): string => {
  const roomMatch = name.match(/^Room\s+(\d+)$/);

  if (roomMatch) {
    const roomNumber = roomMatch[1];
    return i18n.t('common:default_breakout_room_name.pattern', {
      number: roomNumber,
      defaultValue: name,
    });
  }

  return name;
};
